import { render, staticRenderFns } from "./AddOthersIcon.vue?vue&type=template&id=487892dc&scoped=true&"
import script from "./AddOthersIcon.vue?vue&type=script&lang=js&"
export * from "./AddOthersIcon.vue?vue&type=script&lang=js&"
import style0 from "./AddOthersIcon.vue?vue&type=style&index=0&id=487892dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487892dc",
  null
  
)

export default component.exports